import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetNetworksPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/inputs/get-networks-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterNetworkListContext } from '../../network.context';
import { NetworkListFilterFormStep1Controller } from '../network-list-filter-form-step-1/network-list-filter-form-step-1.controller';

export interface NetworkListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetNetworksPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetNetworksPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const NetworkListFilterFormController = (
  props: NetworkListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterNetworkListContext();

  return (
    <MultiStepFormProvider<GetNetworksPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['customerId'],
          component: <NetworkListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
